import { render, staticRenderFns } from "./SlideReleaseDialog.vue?vue&type=template&id=be192536&lang=pug"
import script from "./SlideReleaseDialog.vue?vue&type=script&lang=js"
export * from "./SlideReleaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports